import { LogRequest } from "@/common/types/logs/request.type";
import Box from "../../Box";
import { FileUploader } from "../../FileUploader";
import { getFilenameFromUrl } from "@/common/utils/getFilenameFromUrl";

const RequestLogReason = ({ request }: { request: LogRequest; }) => {
  return (
    <Box className="flex items-end justify-between rounded-xl px-4 py-5">
      <div className="flex flex-col gap-1 h-full">
        <p className="text-xs font-light">
          Motivo
        </p>

        <p className="text-sm font-medium">
          {request.log_reason?.value}
        </p>
      </div>

      {request.log_reason?.file?.url && (
        <FileUploader
          fileName={getFilenameFromUrl(request.log_reason?.file?.url)}
          currentFileUrl={request.log_reason?.file?.url}
          className="flex-row items-center gap-4 px-4 py-3 h-auto min-w-32"
          titleClassName="text-red-500"
          currentFilePlaceholderFileNameClassName="text-nowrap"
          disabled
        />
      )}
    </Box>
  );
};

export default RequestLogReason;
